import { trackCustomPlayerEvent } from ".";

export function trackLinkClick(url: string): void {
    // We only track these when Google Analytics is enabled in the app.
    // If Google Analytics is enabled in your app, we assume you know what you're doing.
    return trackCustomPlayerEvent("click", { event_category: "outbound", event_label: url, transport_type: "beacon" });
}
